export const DivisionDistrictTalukaTranslation = {
    "en": {
      "divisions": {
        "divison": "divison",
        "Amravati": "Amravati",
        "Chhatrapati Sambhaji Nagar": "Chhatrapati Sambhaji Nagar",
        "Kokan": "Kokan",
        "Nagpur": "Nagpur",
        "Nashik": "Nashik",
        "Pune": "Pune"
      },
      "districts": {
        "district": "district",
        "Akola": "Akola",
        "Amravati": "Amravati",
        "Buldhana": "Buldhana",
        "Washim": "Washim",
        "Yavatmal": "Yavatmal",
        "Beed": "Beed",
        "Chhatrapati Sambhaji Nagar": "Chhatrapati Sambhaji Nagar",
        "Dharashiv": "Dharashiv",
        "Hingoli": "Hingoli",
        "Jalna": "Jalna",
        "Latur": "Latur",
        "Nanded": "Nanded",
        "Parbhani": "Parbhani",
        "Palghar": "Palghar",
        "Raigad": "Raigad",
        "Ratnagiri": "Ratnagiri",
        "Sindhudurg": "Sindhudurg",
        "Thane": "Thane",
        "Bhandara": "Bhandara",
        "Chandrapur": "Chandrapur",
        "Gadchiroli": "Gadchiroli",
        "Gondia": "Gondia",
        "Nagpur": "Nagpur",
        "Wardha": "Wardha",
        "Ahilyanagar": "Ahilyanagar",
        "Dhule": "Dhule",
        "Jalgaon": "Jalgaon",
        "Nandurbar": "Nandurbar",
        "Nashik": "Nashik",
        "Kolhapur": "Kolhapur",
        "Pune": "Pune",
        "Sangli": "Sangli",
        "Satara": "Satara",
        "Solapur": "Solapur"
      },
      "talukas": {
        "taluka": "taluka",
        "Akola": "Akola",
        "Akot": "Akot",
        "Balapur": "Balapur",
        "Barshitakli": "Barshitakli",
        "Murtijapur": "Murtijapur",
        "Patur": "Patur",
        "Telhara": "Telhara",
        "Achalpur": "Achalpur",
        "Amravati": "Amravati",
        "Anjangaon Surji": "Anjangaon Surji",
        "Bhatkuli": "Bhatkuli",
        "Chandur Railway": "Chandur Railway",
        "Chandurbazar": "Chandurbazar",
        "Chikhaldara": "Chikhaldara",
        "Daryapur": "Daryapur",
        "Dhamangaon Railway": "Dhamangaon Railway",
        "Dharni": "Dharni",
        "Morshi": "Morshi",
        "Nandgaon-Khandeshwar": "Nandgaon-Khandeshwar",
        "Tiosa": "Tiosa",
        "Warud": "Warud",
        "Buldana": "Buldana",
        "Chikhli": "Chikhli",
        "Deolgaon Raja": "Deolgaon Raja",
        "Jalgaon (Jamod)": "Jalgaon (Jamod)",
        "Khamgaon": "Khamgaon",
        "Lonar": "Lonar",
        "Malkapur": "Malkapur",
        "Mehkar": "Mehkar",
        "Motala": "Motala",
        "Nandura": "Nandura",
        "Sangrampur": "Sangrampur",
        "Shegaon": "Shegaon",
        "Sindkhed Raja": "Sindkhed Raja",
        "Karanja": "Karanja",
        "Malegaon": "Malegaon",
        "Mangrulpir": "Mangrulpir",
        "Manora": "Manora",
        "Risod": "Risod",
        "Washim": "Washim",
        "Arni": "Arni",
        "Babulgaon": "Babulgaon",
        "Darwha": "Darwha",
        "Digras": "Digras",
        "Ghatanji": "Ghatanji",
        "Kalamb": "Kalamb",
        "Kelapur": "Kelapur",
        "Mahagaon": "Mahagaon",
        "Maregaon": "Maregaon",
        "Ner": "Ner",
        "Pusad": "Pusad",
        "Ralegaon": "Ralegaon",
        "Umarkhed": "Umarkhed",
        "Wani": "Wani",
        "Yavatmal": "Yavatmal",
        "Zari-Jamani": "Zari-Jamani",
        "Ambejogai": "Ambejogai",
        "Ashti": "Ashti",
        "Beed": "Beed",
        "Dharur": "Dharur",
        "Georai": "Georai",
        "Kaij": "Kaij",
        "Majalgaon": "Majalgaon",
        "Parli": "Parli",
        "Patoda": "Patoda",
        "Shirur (Kasar)": "Shirur (Kasar)",
        "Wadwani": "Wadwani",
        "Chhatrapati Sambhaji Nagar": "Chhatrapati Sambhaji Nagar",
        "Gangapur": "Gangapur",
        "Kannad": "Kannad",
        "Khuldabad": "Khuldabad",
        "Paithan": "Paithan",
        "Phulambri": "Phulambri",
        "Sillod": "Sillod",
        "Soegaon": "Soegaon",
        "Vaijapur": "Vaijapur",
        "Bhum": "Bhum",
        "Dharashiv": "Dharashiv",
        "Lohara": "Lohara",
        "Omarga": "Omarga",
        "Paranda": "Paranda",
        "Tuljapur": "Tuljapur",
        "Washi": "Washi",
        "Aundha (Nagnath)": "Aundha (Nagnath)",
        "Hingoli": "Hingoli",
        "Kalamnuri": "Kalamnuri",
        "Sengaon": "Sengaon",
        "Vasmath": "Vasmath",
        "Ambad": "Ambad",
        "Badnapur": "Badnapur",
        "Bhokardan": "Bhokardan",
        "Ghansawangi": "Ghansawangi",
        "Jafrabad": "Jafrabad",
        "Jalna": "Jalna",
        "Mantha": "Mantha",
        "Partur": "Partur",
        "Ahmadpur": "Ahmadpur",
        "Ausa": "Ausa",
        "Chakur": "Chakur",
        "Deoni": "Deoni",
        "Jalkot": "Jalkot",
        "Latur": "Latur",
        "Nilanga": "Nilanga",
        "Renapur": "Renapur",
        "Shirur Anantpal": "Shirur Anantpal",
        "Udgir": "Udgir",
        "Ardhapur": "Ardhapur",
        "Bhokar": "Bhokar",
        "Biloli": "Biloli",
        "Deglur": "Deglur",
        "Dharmabad": "Dharmabad",
        "Hadgaon": "Hadgaon",
        "Himayatnagar": "Himayatnagar",
        "Kandhar": "Kandhar",
        "Kinwat": "Kinwat",
        "Loha": "Loha",
        "Mahur": "Mahur",
        "Mudkhed": "Mudkhed",
        "Mukhed": "Mukhed",
        "Naigaon (Khairgaon)": "Naigaon (Khairgaon)",
        "Nanded": "Nanded",
        "Umri": "Umri",
        "Gangakhed": "Gangakhed",
        "Jintur": "Jintur",
        "Manwath": "Manwath",
        "Palam": "Palam",
        "Parbhani": "Parbhani",
        "Pathri": "Pathri",
        "Purna": "Purna",
        "Selu": "Selu",
        "Sonpeth": "Sonpeth",
        "Dahanu": "Dahanu",
        "Jawhar": "Jawhar",
        "Mokhada": "Mokhada",
        "Palghar": "Palghar",
        "Talasari": "Talasari",
        "Vasai": "Vasai",
        "Vikramgad": "Vikramgad",
        "Wada": "Wada",
        "Alibag": "Alibag",
        "Karjat": "Karjat",
        "Khalapur": "Khalapur",
        "Mahad": "Mahad",
        "Mangaon": "Mangaon",
        "Mhasla": "Mhasla",
        "Murud": "Murud",
        "Panvel": "Panvel",
        "Pen": "Pen",
        "Poladpur": "Poladpur",
        "Roha": "Roha",
        "Shrivardhan": "Shrivardhan",
        "Sudhagad": "Sudhagad",
        "Tala": "Tala",
        "Uran": "Uran",
        "Chiplun": "Chiplun",
        "Dapoli": "Dapoli",
        "Guhagar": "Guhagar",
        "Khed": "Khed",
        "Lanja": "Lanja",
        "Mandangad": "Mandangad",
        "Rajapur": "Rajapur",
        "Ratnagiri": "Ratnagiri",
        "Sangameshwar": "Sangameshwar",
        "Devgad": "Devgad",
        "Dodamarg": "Dodamarg",
        "Kankavli": "Kankavli",
        "Kudal": "Kudal",
        "Malwan": "Malwan",
        "Sawantwadi": "Sawantwadi",
        "Vaibhavvadi": "Vaibhavvadi",
        "Vengurla": "Vengurla",
        "Ambarnath": "Ambarnath",
        "Bhiwandi": "Bhiwandi",
        "Kalyan": "Kalyan",
        "Murbad": "Murbad",
        "Shahapur": "Shahapur",
        "Thane": "Thane",
        "Ulhasnagar": "Ulhasnagar",
        "Bhandara": "Bhandara",
        "Lakhandur": "Lakhandur",
        "Lakhani": "Lakhani",
        "Mohadi": "Mohadi",
        "Pauni": "Pauni",
        "Sakoli": "Sakoli",
        "Tumsar": "Tumsar",
        "Ballarpur": "Ballarpur",
        "Bhadravati": "Bhadravati",
        "Brahmapuri": "Brahmapuri",
        "Chandrapur": "Chandrapur",
        "Chimur": "Chimur",
        "Gondpipri": "Gondpipri",
        "Jiwati": "Jiwati",
        "Korpana": "Korpana",
        "Mul": "Mul",
        "Nagbhid": "Nagbhid",
        "Pombhurna": "Pombhurna",
        "Rajura": "Rajura",
        "Sawali": "Sawali",
        "Sindewahi": "Sindewahi",
        "Warora": "Warora",
        "Aheri": "Aheri",
        "Armori": "Armori",
        "Bhamragad": "Bhamragad",
        "Chamorshi": "Chamorshi",
        "Desaiganj (Vadasa)": "Desaiganj (Vadasa)",
        "Dhanora": "Dhanora",
        "Etapalli": "Etapalli",
        "Gadchiroli": "Gadchiroli",
        "Korchi": "Korchi",
        "Kurkheda": "Kurkheda",
        "Mulchera": "Mulchera",
        "Sironcha": "Sironcha",
        "Amgaon": "Amgaon",
        "Arjuni Morgaon": "Arjuni Morgaon",
        "Deori": "Deori",
        "Gondiya": "Gondiya",
        "Goregaon": "Goregaon",
        "Sadak-Arjuni": "Sadak-Arjuni",
        "Salekasa": "Salekasa",
        "Tirora": "Tirora",
        "Bhiwapur": "Bhiwapur",
        "Hingna": "Hingna",
        "Kalameshwar": "Kalameshwar",
        "Kamptee": "Kamptee",
        "Katol": "Katol",
        "Kuhi": "Kuhi",
        "Mauda": "Mauda",
        "Nagpur (Rural)": "Nagpur (Rural)",
        "Nagpur (Urban)": "Nagpur (Urban)",
        "Narkhed": "Narkhed",
        "Parseoni": "Parseoni",
        "Ramtek": "Ramtek",
        "Savner": "Savner",
        "Umred": "Umred",
        "Arvi": "Arvi",
        "Deoli": "Deoli",
        "Hinganghat": "Hinganghat",
        "Samudrapur": "Samudrapur",
        "Seloo": "Seloo",
        "Wardha": "Wardha",
        "Akole": "Akole",
        "Jamkhed": "Jamkhed",
        "Kopargaon": "Kopargaon",
        "Ahilyanagar": "Ahilyanagar",
        "Nevasa": "Nevasa",
        "Parner": "Parner",
        "Pathardi": "Pathardi",
        "Rahta": "Rahta",
        "Rahuri": "Rahuri",
        "Sangamner": "Sangamner",
        "Shevgaon": "Shevgaon",
        "Shrigonda": "Shrigonda",
        "Shrirampur": "Shrirampur",
        "Dhule": "Dhule",
        "Sakri": "Sakri",
        "Shirpur": "Shirpur",
        "Sindkhede": "Sindkhede",
        "Amalner": "Amalner",
        "Bhadgaon": "Bhadgaon",
        "Bhusawal": "Bhusawal",
        "Bodvad": "Bodvad",
        "Chalisgaon": "Chalisgaon",
        "Chopda": "Chopda",
        "Dharangaon": "Dharangaon",
        "Erandol": "Erandol",
        "Jalgaon": "Jalgaon",
        "Jamner": "Jamner",
        "Muktainagar (Edlabad)": "Muktainagar (Edlabad)",
        "Pachora": "Pachora",
        "Parola": "Parola",
        "Raver": "Raver",
        "Yawal": "Yawal",
        "Akkalkuwa": "Akkalkuwa",
        "Akrani": "Akrani",
        "Nandurbar": "Nandurbar",
        "Nawapur": "Nawapur",
        "Shahade": "Shahade",
        "Talode": "Talode",
        "Baglan": "Baglan",
        "Chandvad": "Chandvad",
        "Deola": "Deola",
        "Dindori": "Dindori",
        "Igatpuri": "Igatpuri",
        "Kalwan": "Kalwan",
        "Nandgaon": "Nandgaon",
        "Nashik": "Nashik",
        "Niphad": "Niphad",
        "Peth": "Peth",
        "Sinnar": "Sinnar",
        "Surgana": "Surgana",
        "Trimbakeshwar": "Trimbakeshwar",
        "Yevla": "Yevla",
        "Ajra": "Ajra",
        "Bhudargad": "Bhudargad",
        "Chandgad": "Chandgad",
        "Gadhinglaj": "Gadhinglaj",
        "Gaganbawada": "Gaganbawada",
        "Hatkanangle": "Hatkanangle",
        "Kagal": "Kagal",
        "Karvir": "Karvir",
        "Panhala": "Panhala",
        "Radhanagari": "Radhanagari",
        "Shahuwadi": "Shahuwadi",
        "Shirol": "Shirol",
        "Ambegaon": "Ambegaon",
        "Baramati": "Baramati",
        "Bhor": "Bhor",
        "Daund": "Daund",
        "Haveli": "Haveli",
        "Indapur": "Indapur",
        "Junnar": "Junnar",
        "Mawal": "Mawal",
        "Mulshi": "Mulshi",
        "Pune City": "Pune City",
        "Purandhar": "Purandhar",
        "Shirur": "Shirur",
        "Velhe": "Velhe",
        "Atpadi": "Atpadi",
        "Jat": "Jat",
        "Kadegaon": "Kadegaon",
        "Kavathemahankal": "Kavathemahankal",
        "Khanapur": "Khanapur",
        "Miraj": "Miraj",
        "Palus": "Palus",
        "Shirala": "Shirala",
        "Tasgaon": "Tasgaon",
        "Walwa": "Walwa",
        "Jaoli": "Jaoli",
        "Karad": "Karad",
        "Khandala": "Khandala",
        "Khatav": "Khatav",
        "Koregaon": "Koregaon",
        "Mahabaleshwar": "Mahabaleshwar",
        "Man": "Man",
        "Patan": "Patan",
        "Phaltan": "Phaltan",
        "Satara": "Satara",
        "Wai": "Wai",
        "Akkalkot": "Akkalkot",
        "Barshi": "Barshi",
        "Karmala": "Karmala",
        "Madha": "Madha",
        "Malshiras": "Malshiras",
        "Mangalvedhe": "Mangalvedhe",
        "Mohol": "Mohol",
        "Pandharpur": "Pandharpur",
        "Sangole": "Sangole",
        "Solapur North": "Solapur North",
        "Solapur South": "Solapur South"
      }
    },
    "mr": {
      "divisions": {
        "divison": "divison",
        "Amravati": "अमरावती",
        "Chhatrapati Sambhaji Nagar": "छत्रपती संभाजीनगर",
        "Kokan": "कोकण",
        "Nagpur": "नागपूर",
        "Nashik": "नाशिक",
        "Pune": "पुणे"
      },
      "districts": {
        "district": "district",
        "Akola": "अकोला",
        "Amravati": "अमरावती",
        "Buldhana": "बुलढाणा",
        "Washim": "अकोला",
        "Yavatmal": "यवतमाळ",
        "Beed": "बीड",
        "Chhatrapati Sambhaji Nagar": "छत्रपती संभाजीनगर",
        "Dharashiv": "धाराशिव",
        "Hingoli": "हिंगोली",
        "Jalna": "जालना",
        "Latur": "लातूर",
        "Nanded": "नांदेड",
        "Parbhani": "परभणी",
        "Palghar": "पालघर",
        "Raigad": "रायगड",
        "Ratnagiri": "रत्नागिरी",
        "Sindhudurg": "रत्नागिरी",
        "Thane": "ठाणे",
        "Bhandara": "भंडारा",
        "Chandrapur": "गडचिरोली",
        "Gadchiroli": "गडचिरोली",
        "Gondia": "गोंदिया",
        "Nagpur": "नागपूर",
        "Wardha": "वर्धा",
        "Ahilyanagar": "अहमदनगर",
        "Dhule": "धुळे",
        "Jalgaon": "जळगाव",
        "Nandurbar": "नंदुरबार",
        "Nashik": "नाशिक",
        "Kolhapur": "कोल्हापूर",
        "Pune": "पुणे",
        "Sangli": "सांगली",
        "Satara": "सातारा",
        "Solapur": "सोलापूर"
      },
      "talukas": {
        "taluka": "taluka",
        "Akola": "अकोला",
        "Akot": "अकोट",
        "Balapur": "बाळापूर",
        "Barshitakli": "बार्शीटाकळी",
        "Murtijapur": "मूर्तिजापूर",
        "Patur": "पातूर",
        "Telhara": "तेल्हारा",
        "Achalpur": "अचलपूर",
        "Amravati": "अमरावती",
        "Anjangaon Surji": "अंजनगाव सुर्जी",
        "Bhatkuli": "भातकुली",
        "Chandur Railway": "चांदूर रेल्वे",
        "Chandurbazar": "चांदूरबाजार",
        "Chikhaldara": "चिखलदरा",
        "Daryapur": "दर्यापूर",
        "Dhamangaon Railway": "धामणगाव रेल्वे",
        "Dharni": "धारणी",
        "Morshi": "मोर्शी",
        "Nandgaon-Khandeshwar": "नांदगाव-खांडेश्वर",
        "Tiosa": "तिवसा",
        "Warud": "वारुड",
        "Buldana": "बुलढाणा",
        "Chikhli": "चिखली",
        "Deolgaon Raja": "देऊळगाव राजा",
        "Jalgaon (Jamod)": "जळगाव (जामोद)",
        "Khamgaon": "खामगाव",
        "Lonar": "लोणार",
        "Malkapur": "मलकापूर",
        "Mehkar": "मेहकर",
        "Motala": "मोताळा",
        "Nandura": "नांदुरा",
        "Sangrampur": "संग्रामपूर",
        "Shegaon": "शेगाव",
        "Sindkhed Raja": "सिंदखेड राजा",
        "Karanja": "कारंजा",
        "Malegaon": "मालेगाव",
        "Mangrulpir": "मंगरुळपीर",
        "Manora": "मानोरा",
        "Risod": "रिसोड",
        "Washim": "वाशिम",
        "Arni": "आर्णी",
        "Babulgaon": "बाभूळगाव",
        "Darwha": "दारव्हा",
        "Digras": "दिग्रस",
        "Ghatanji": "घाटंजी",
        "Kalamb": "कळंब",
        "Kelapur": "केळापूर",
        "Mahagaon": "महागाव",
        "Maregaon": "मारेगाव",
        "Ner": "नेर",
        "Pusad": "पुसद",
        "Ralegaon": "राळेगाव",
        "Umarkhed": "उमरखेड",
        "Wani": "वणी",
        "Yavatmal": "यवतमाळ",
        "Zari-Jamani": "झरी-जामणी",
        "Ambejogai": "अंबेजोगाई",
        "Ashti": "आष्टी",
        "Beed": "बीड",
        "Dharur": "धारूर",
        "Georai": "गेवराई",
        "Kaij": "केज",
        "Majalgaon": "माजलगाव",
        "Parli": "परळी",
        "Patoda": "पाटोदा",
        "Shirur (Kasar)": "शिरूर (कासार)",
        "Wadwani": "वाडवणी",
        "Chhatrapati Sambhaji Nagar": "छत्रपती संभाजी नगर",
        "Gangapur": "गंगापूर",
        "Kannad": "कन्नड",
        "Khuldabad": "खुलताबाद",
        "Paithan": "पैठण",
        "Phulambri": "फुलंब्री",
        "Sillod": "सिल्लोड",
        "Soegaon": "सोयगाव",
        "Vaijapur": "वैजापूर",
        "Bhum": "भूम",
        "Dharashiv": "धाराशिव",
        "Lohara": "लोहारा",
        "Omarga": "उमरगा",
        "Paranda": "परंडा",
        "Tuljapur": "तुळजापूर",
        "Washi": "वाशी",
        "Aundha (Nagnath)": "औंढा (नागनाथ)",
        "Hingoli": "हिंगोली",
        "Kalamnuri": "कळमनुरी",
        "Sengaon": "सेनगाव",
        "Vasmath": "वसमत",
        "Ambad": "अंबड",
        "Badnapur": "बदनापूर",
        "Bhokardan": "भोकरदन",
        "Ghansawangi": "घनसावंगी",
        "Jafrabad": "जाफ्राबाद",
        "Jalna": "जालना",
        "Mantha": "मंठा",
        "Partur": "परतूर",
        "Ahmadpur": "अहमदपूर",
        "Ausa": "औसा",
        "Chakur": "चाकूर",
        "Deoni": "देवनी",
        "Jalkot": "जळकोट",
        "Latur": "लातूर",
        "Nilanga": "निलंगा",
        "Renapur": "रेणापूर",
        "Shirur Anantpal": "शिरूर अनंतपाळ",
        "Udgir": "उदगीर",
        "Ardhapur": "अर्धापूर",
        "Bhokar": "भोकर",
        "Biloli": "बिलोली",
        "Deglur": "देगलूर",
        "Dharmabad": "धर्माबाद",
        "Hadgaon": "हदगाव",
        "Himayatnagar": "हिमायतनगर",
        "Kandhar": "कंधार",
        "Kinwat": "किनवट",
        "Loha": "लोहा",
        "Mahur": "माहूर",
        "Mudkhed": "मुदखेड",
        "Mukhed": "मुखेड",
        "Naigaon (Khairgaon)": "नायगाव (खैरगाव)",
        "Nanded": "नांदेड",
        "Umri": "उमरी",
        "Gangakhed": "गंगाखेड",
        "Jintur": "जिंतूर",
        "Manwath": "मानवत",
        "Palam": "पालम",
        "Parbhani": "परभणी",
        "Pathri": "पाथरी",
        "Purna": "पूर्णा",
        "Selu": "सेलू",
        "Sonpeth": "सोनपेठ",
        "Dahanu": "डहाणू",
        "Jawhar": "जव्हार",
        "Mokhada": "मोखाडा",
        "Palghar": "पालघर",
        "Talasari": "तलासरी",
        "Vasai": "वसई",
        "Vikramgad": "विक्रमगड",
        "Wada": "वाडा",
        "Alibag": "अलिबाग",
        "Karjat": "कर्जत",
        "Khalapur": "खालापूर",
        "Mahad": "महाड",
        "Mangaon": "माणगाव",
        "Mhasla": "म्हसळा",
        "Murud": "मुरुड",
        "Panvel": "पनवेल",
        "Pen": "पेण",
        "Poladpur": "पोलादपूर",
        "Roha": "रोहा",
        "Shrivardhan": "श्रीवर्धन",
        "Sudhagad": "सुधागड",
        "Tala": "तळा",
        "Uran": "उरण",
        "Chiplun": "चिपळूण",
        "Dapoli": "दापोली",
        "Guhagar": "गुहागर",
        "Khed": "खेड",
        "Lanja": "लांजा",
        "Mandangad": "मंडणगड",
        "Rajapur": "राजापूर",
        "Ratnagiri": "रत्नागिरी",
        "Sangameshwar": "संगमेश्वर",
        "Devgad": "देवगड",
        "Dodamarg": "दोडामार्ग",
        "Kankavli": "कणकवली",
        "Kudal": "कुडाळ",
        "Malwan": "मालवण",
        "Sawantwadi": "सावंतवाडी",
        "Vaibhavvadi": "वैभववाडी",
        "Vengurla": "वेंगुर्ला",
        "Ambarnath": "अंबरनाथ",
        "Bhiwandi": "भिवंडी",
        "Kalyan": "कल्याण",
        "Murbad": "मुरबाड",
        "Shahapur": "शहापूर",
        "Thane": "ठाणे",
        "Ulhasnagar": "उल्हासनगर",
        "Bhandara": "भंडारा",
        "Lakhandur": "लाखांदूर",
        "Lakhani": "लाखनी",
        "Mohadi": "मोहाडी",
        "Pauni": "पौनी",
        "Sakoli": "साकोली",
        "Tumsar": "तुमसर",
        "Ballarpur": "बल्लारपूर",
        "Bhadravati": "भद्रावती",
        "Brahmapuri": "ब्रह्मपुरी",
        "Chandrapur": "चंद्रपूर",
        "Chimur": "चिमूर",
        "Gondpipri": "गोंडपिपरी",
        "Jiwati": "जिवती",
        "Korpana": "कोरपना",
        "Mul": "मुल",
        "Nagbhid": "नागभीड",
        "Pombhurna": "पोंभुर्णा",
        "Rajura": "राजुरा",
        "Sawali": "सावली",
        "Sindewahi": "सिंदेवाही",
        "Warora": "वरोरा",
        "Aheri": "अहेरी",
        "Armori": "आरमोरी",
        "Bhamragad": "भामरागड",
        "Chamorshi": "चामोर्शी",
        "Desaiganj (Vadasa)": "देसाईगंज (वडसा)",
        "Dhanora": "धानोरा",
        "Etapalli": "एटापल्ली",
        "Gadchiroli": "गडचिरोली",
        "Korchi": "कोरची",
        "Kurkheda": "कुरखेडा",
        "Mulchera": "मुलचेरा",
        "Sironcha": "सिरोंचा",
        "Amgaon": "आमगाव",
        "Arjuni Morgaon": "अर्जुनी मोरगाव",
        "Deori": "देवरी",
        "Gondiya": "गोंदिया",
        "Goregaon": "गोरेगाव",
        "Sadak-Arjuni": "सडक-अर्जुनी",
        "Salekasa": "सालेकसा",
        "Tirora": "तिरोरा",
        "Bhiwapur": "भिवापूर",
        "Hingna": "हिंगणा",
        "Kalameshwar": "कळमेश्वर",
        "Kamptee": "काम्पटी",
        "Katol": "काटोल",
        "Kuhi": "कुही",
        "Mauda": "मौदा",
        "Nagpur (Rural)": "नागपूर (ग्रामीण)",
        "Nagpur (Urban)": "नागपूर (शहरी)",
        "Narkhed": "नरखेड",
        "Parseoni": "परसोनी",
        "Ramtek": "रामटेक",
        "Savner": "सावनेर",
        "Umred": "उमरेड",
        "Arvi": "आर्वी",
        "Deoli": "देवळी",
        "Hinganghat": "हिंगणघाट",
        "Samudrapur": "समुद्रपूर",
        "Seloo": "सेलू",
        "Wardha": "वर्धा",
        "Akole": "अकोले",
        "Jamkhed": "जामखेड",
        "Kopargaon": "कोपरगाव",
        "Ahilyanagar": "अहिल्यानगर",
        "Nevasa": "नेवासा",
        "Parner": "पारनेर",
        "Pathardi": "पाथर्डी",
        "Rahta": "राहता",
        "Rahuri": "राहुरी",
        "Sangamner": "संगमनेर",
        "Shevgaon": "शेवगाव",
        "Shrigonda": "श्रीगोंदा",
        "Shrirampur": "श्रीरामपूर",
        "Dhule": "धुळे",
        "Sakri": "साक्री",
        "Shirpur": "शिरपूर",
        "Sindkhede": "सिंदखेडे",
        "Amalner": "अमळनेर",
        "Bhadgaon": "भडगाव",
        "Bhusawal": "भुसावळ",
        "Bodvad": "बोदवड",
        "Chalisgaon": "चाळीसगाव",
        "Chopda": "चोपडा",
        "Dharangaon": "धरणगाव",
        "Erandol": "एरंडोल",
        "Jalgaon": "जळगाव",
        "Jamner": "जामनेर",
        "Muktainagar (Edlabad)": "मुक्ताईनगर (एदलाबाद)",
        "Pachora": "पाचोरा",
        "Parola": "पारोळा",
        "Raver": "रावेर",
        "Yawal": "यावल",
        "Akkalkuwa": "अक्कलकुवा",
        "Akrani": "अक्राणी",
        "Nandurbar": "नंदुरबार",
        "Nawapur": "नवापूर",
        "Shahade": "शहादे",
        "Talode": "तळोदे",
        "Baglan": "बागलाण",
        "Chandvad": "चांदवड",
        "Deola": "देवळा",
        "Dindori": "दिंडोरी",
        "Igatpuri": "इगतपुरी",
        "Kalwan": "कळवण",
        "Nandgaon": "नांदगाव",
        "Nashik": "नाशिक",
        "Niphad": "निफाड",
        "Peth": "पेठ",
        "Sinnar": "सिन्नर",
        "Surgana": "सुरगाणा",
        "Trimbakeshwar": "त्र्यंबकेश्वर",
        "Yevla": "येवला",
        "Ajra": "आजरा",
        "Bhudargad": "भुदरगड",
        "Chandgad": "चंदगड",
        "Gadhinglaj": "गडहिंग्लज",
        "Gaganbawada": "गगनबावडा",
        "Hatkanangle": "हातकणंगले",
        "Kagal": "कागल",
        "Karvir": "करवीर",
        "Panhala": "पन्हाळा",
        "Radhanagari": "राधानगरी",
        "Shahuwadi": "शाहूवाडी",
        "Shirol": "शिरोळ",
        "Ambegaon": "आंबेगाव",
        "Baramati": "बारामती",
        "Bhor": "भोर",
        "Daund": "दौंड",
        "Haveli": "हवेली",
        "Indapur": "इंदापूर",
        "Junnar": "जुन्नर",
        "Mawal": "मावळ",
        "Mulshi": "मुळशी",
        "Pune City": "पुणे शहर",
        "Purandhar": "पुरंदर",
        "Shirur": "शिरूर",
        "Velhe": "वेल्हे",
        "Atpadi": "आटपाडी",
        "Jat": "जाट",
        "Kadegaon": "कडेगाव",
        "Kavathemahankal": "कवठेमहांकाळ",
        "Khanapur": "खानापूर",
        "Miraj": "मिरज",
        "Palus": "पलूस",
        "Shirala": "शिराळा",
        "Tasgaon": "तासगाव",
        "Walwa": "वाळवा",
        "Jaoli": "जावळी",
        "Karad": "कराड",
        "Khandala": "खंडाळा",
        "Khatav": "खटाव",
        "Koregaon": "कोरेगाव",
        "Mahabaleshwar": "महाबळेश्वर",
        "Man": "माणूस",
        "Patan": "पाटण",
        "Phaltan": "फलटण",
        "Satara": "सातारा",
        "Wai": "वाई",
        "Akkalkot": "अक्कलकोट",
        "Barshi": "बार्शी",
        "Karmala": "करमाळा",
        "Madha": "माढा",
        "Malshiras": "माळशिरस",
        "Mangalvedhe": "मंगळवेढा",
        "Mohol": "मोहोळ",
        "Pandharpur": "पंढरपूर",
        "Sangole": "सांगोले",
        "Solapur North": "सोलापूर उत्तर",
        "Solapur South": "सोलापूर दक्षिण"
      }
    }
  };